import React, { useEffect, useState } from "react";
import MainHeader from "./universal/Header/MainHeader";
import BottomNav from "./universal/Footer/BottomNav";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Library from "./Pages/SideBar/Libraries/Library";
import Articles from "./Pages/SideBar/Libraries/Articles";
import Videos from "./Pages/Videos/Videos";
import BookPdf from "./Pages/SideBar/Libraries/BookPdf";
import "./universal/universal.css";
import UserProfile from "./Pages/UserProfile/UserProfile";
import Community from "./Pages/Community/Community";
import Sign from "./Authentication/GetIn/Sign";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfile } from "../redux/dataFetchers/ProfileApi";
import { saveAnonymousUser } from "../redux/dataFetchers/anonymousUser";
import AuthSuccess from "./Authentication/GetIn/AuthSuccess";
import { LinkedInPopUp } from "react-linkedin-login-oauth2";
import HomePage from "./Pages/HomePage/HomePage";
import ChatShell from "./ChatShell/ChatShell";
import { HiX } from "react-icons/hi";
import Main from "../Main";
import JavaQuiz from "./Quizzes/JavaQuiz";
import Share from "./Share";
import UIQuiz from "./Quizzes/UIQuiz";
import DevopsQuiz from "./Quizzes/DevopsQuiz";
import Proceed from "../Proceed";
import TestQuiz from "./Quizzes/TestQuiz";
import FeedInterest from "./FeedInterest";
import ReactGA from "react-ga";

ReactGA.initialize("UA-209783951-1");

const Collector = () => {
  const [signupbanner, setBanner] = useState(false);
  const [middleFeed, setMiddleFeed] = useState("");
  const dispatch = useDispatch();
  const reduxState = useSelector((state) => state);

  useEffect(() => {
    dispatch(saveAnonymousUser());
    dispatch(fetchProfile());

    ReactGA.pageview("/");

    const timer = setTimeout(() => {
      setBanner(true);
    }, 5 * 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div className="flex flex-col">
        <MainHeader />
        <FeedInterest />

        <Route
          render={(props) => (
            <div
              className={
                "md:mt-20 " +
                ((props.history.location.pathname === "/" ||
                  props.history.location.pathname?.split("/")[1] === "posts" ||
                  props.history.location.pathname?.split("/")[1] === "qnas" ||
                  props.history.location.pathname?.split("/")[1] === "polls") &&
                  "md:ml-60")
              }
            >
              <Switch>
                <Route
                  exact
                  path={["/", "/posts/*", "/qnas/*", "/polls/*"]}
                  component={HomePage}
                />
                <Route path="/community" component={Community} />
                <Route path="/library" component={Library} />
                <Route path="/articles" component={Articles} />
                <Route path="/bookpdf" component={BookPdf} />
                <Route path={["/videos/*", "/videos"]} component={Videos} />
                <Route
                  path={["/profile", "/profile/*"]}
                  component={UserProfile}
                />
                <Route path="/linkedin" component={LinkedInPopUp} />
                <Route path="/auth/google/success" component={AuthSuccess} />
                <Route
                  path={["/fellowbot", "/sourcingbot", "/techbot"]}
                  component={ChatShell}
                />
                {reduxState.authUser.isAuthenticated && (
                  <Route
                    exact
                    path="/quiz"
                    component={() => <Main uid={reduxState.info.info.uid} />}
                  />
                )}
                {reduxState.authUser.isAuthenticated && (
                  <Route
                    exact
                    path="/quiz/share-experience"
                    component={() => <Share />}
                  />
                )}
                {reduxState.authUser.isAuthenticated && (
                  <Route
                    exact
                    path="/quiz/boolean-basics-quiz"
                    component={() => (
                      <TestQuiz
                        uid={reduxState.info.info.uid}
                        name={reduxState.info.info.name}
                        email={reduxState.info.info.username}
                      />
                    )}
                  />
                )}
                {reduxState.authUser.isAuthenticated && (
                  <Route
                    exact
                    path="/quiz/java-stack-quiz"
                    component={() => (
                      <JavaQuiz
                        uid={reduxState.info.info.uid}
                        name={reduxState.info.info.name}
                        email={reduxState.info.info.username}
                      />
                    )}
                  />
                )}
                {reduxState.authUser.isAuthenticated && (
                  <Route
                    exact
                    path="/quiz/ui-quiz"
                    component={() => (
                      <UIQuiz
                        uid={reduxState.info.info.uid}
                        name={reduxState.info.info.name}
                        email={reduxState.info.info.username}
                      />
                    )}
                  />
                )}
                {reduxState.authUser.isAuthenticated && (
                  <Route
                    exact
                    path="/quiz/devops-quiz"
                    component={() => (
                      <DevopsQuiz
                        uid={reduxState.info.info.uid}
                        name={reduxState.info.info.name}
                        email={reduxState.info.info.username}
                      />
                    )}
                  />
                )}
                {reduxState.authUser.isAuthenticated && (
                  <Route
                    exact
                    path="/quiz/monk-scholarship"
                    component={() => (
                      <TestQuiz
                        uid={reduxState.info.info.uid}
                        name={reduxState.info.info.name}
                        email={reduxState.info.info.username}
                      />
                    )}
                  />
                )}
                {!reduxState.authUser.isAuthenticated && (
                  <Route
                    exact
                    path="/quiz"
                    component={() => <Main uid={null} />}
                  />
                )}
                {!reduxState.authUser.isAuthenticated && (
                  <Route exact path="/quiz/recro-hiring" component={Proceed} />
                )}
                {!reduxState.authUser.isAuthenticated && (
                  <Route
                    exact
                    path="/quiz/tricog-health-hiring"
                    component={Proceed}
                  />
                )}
                {!reduxState.authUser.isAuthenticated && (
                  <Route
                    exact
                    path="/quiz/monk-scholarship"
                    component={Proceed}
                  />
                )}
              </Switch>
            </div>
          )}
        />

        {/* <DeskFooter /> */}
        <BottomNav />
        {!reduxState.authUser.isAuthenticated && (
          <div
            className="signupbanner self-center flex-row items-center justify-between mx-10 fixed bottom-20 md:bottom-10 w-full md:w-1/2 items-center p-4  glass gap-4"
            style={{ display: signupbanner ? "flex" : "none" }}
          >
            <div></div>
            <div className="flex flex-col items-center gap-4">
              <h3>Sign Up for More Such Content</h3>
              <div className="w-52 md:w-64">
                <Sign btn={true} />
              </div>
              <h6>or you can SignIn also :p</h6>
            </div>
            <div className="self-start cursor-pointer">
              <HiX size={20} color="#B0343C" onClick={() => setBanner(false)} />{" "}
            </div>
          </div>
        )}
      </div>
    </Router>
  );
};

export default Collector;
